<template>
  <section class="section">
    <div class="section-body">
      <div class="card">
        <div class="card-header">
          <v-icon color="pink">edit</v-icon>
          <h4>{{ $t("messages.general.manageData") }}</h4>
        </div>
        <div class="card-body">
          <v-card width="100%">
            <v-row>
              <v-col
                cols="10"
                style="padding-top: 0; padding-bottom: 0; padding-right: 0;text-align: right;"
              >
                <p style="color: red; margin: 0"></p>
              </v-col>
              <v-col
                style="padding-top: 0; padding-bottom: 0; padding-right: 5px;"
              >
                <p style="margin: 0"></p>
              </v-col>
            </v-row>
          </v-card>
          <form>
            <div
              class="form-row flex-column justify-content-center align-items-center mt-5"
            >
              <div class="form-group" style="width: 100%">
                <div class="form-inline">
                  <div
                    class="form-group"
                    style="width: 60%; justify-content: center;"
                  >
                    <div class="form-inline"></div>
                  </div>
                  <div
                    class="form-group"
                    style="width: 40%; justify-content: flex-end;"
                  >
                    <div class="form-inline">
                      <button
                        type="button"
                        class="btn btn-primary btn-lg"
                        @click="saveCredit()"
                      >
                        {{ $t("messages.general.save") }}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </form>

          <v-card>
            <b-table
              bordered
              hover
              small
              responsive
              caption-top
              class="table table-striped text-center"
              :sort-by.sync="bTable.sortBy"
              :sort-desc.sync="bTable.sortDesc"
              :items="bTable.items"
              :fields="bTable.fields"
              :per-page="perPage"
              :current-page="currentPage"
            >
              <template slot="table-caption">
                <div class="float-left">
                  <b class="mr-2">{{
                    $t("messages.general.table.paginationinfo")
                  }}</b>
                  <b-form-select
                    v-model="perPage"
                    :options="perPageOptions"
                    size="sm"
                    style="width:70px"
                  />
                </div>
                <b-pagination
                  class="float-right"
                  size="sm"
                  :total-rows="bTable.items.length"
                  v-model="currentPage"
                  :per-page="perPage"
                />
                <div
                  v-if="bTable.items.length > 0"
                  class="float-right data-table-page-info"
                >
                  {{
                    Number(
                      currentPage > 1
                        ? (currentPage - 1) * perPage + 1
                        : currentPage
                    ).toLocaleString()
                  }}
                  -
                  {{
                    Number(
                      currentPage * perPage > bTable.items.length
                        ? bTable.items.length
                        : currentPage * perPage
                    ).toLocaleString()
                  }}
                  {{ $t("messages.general.fromRecords") }}
                  {{ Number(bTable.items.length).toLocaleString() }}
                </div>
                <div
                  v-if="bTable.items.length <= 0"
                  class="float-right data-table-page-info"
                >
                  0 - 0
                  {{ $t("messages.general.fromRecords") }}
                  {{ Number(bTable.items.length).toLocaleString() }}
                </div>
              </template>

              <template v-slot:cell(CREDIT)="data">
                <div class="text-center">
                  <input
                    type="number"
                    min="0"
                    class="form-control col mr-2"
                    style="text-align:right"
                    v-model="data.item.CREDIT"
                  />
                </div>
              </template>

              <template slot="table-caption">
                <div
                  style="position: absolute; bottom: -65px; width: 100%; height: 65px; padding-top: 10px; border-color: #fff; box-shadow: 0 3px 1px -2px rgba(0,0,0,.2), 0 2px 2px 0 rgba(0,0,0,.14), 0 1px 5px 0 rgba(0,0,0,.12);"
                >
                  <div class="float-left">
                    <b class="mr-2">{{
                      $t("messages.general.table.paginationinfo")
                    }}</b>
                    <b-form-select
                      v-model="perPage"
                      :options="perPageOptions"
                      size="sm"
                      style="width:70px"
                    />
                  </div>
                  <b-pagination
                    class="float-right"
                    size="sm"
                    :total-rows="bTable.items.length"
                    v-model="currentPage"
                    :per-page="perPage"
                    style="padding-top: 10px"
                  />
                  <div
                    v-if="bTable.items.length > 0"
                    class="float-right data-table-page-info"
                    style="padding-top: 14px"
                  >
                    {{
                      Number(
                        currentPage > 1
                          ? (currentPage - 1) * perPage + 1
                          : currentPage
                      ).toLocaleString()
                    }}
                    -
                    {{
                      Number(
                        currentPage * perPage > bTable.items.length
                          ? bTable.items.length
                          : currentPage * perPage
                      ).toLocaleString()
                    }}
                    {{ $t("messages.general.fromRecords") }}
                    {{ Number(bTable.items.length).toLocaleString() }}
                  </div>
                  <div
                    v-if="bTable.items.length <= 0"
                    class="float-right data-table-page-info"
                    style="padding-top: 14px"
                  >
                    0 - 0
                    {{ $t("messages.general.fromRecords") }}
                    {{ Number(bTable.items.length).toLocaleString() }}
                  </div>
                </div>
              </template>
            </b-table>
          </v-card>

          <v-dialog v-model="dialogConfirmSuccess" max-width="600px">
            <v-card tile>
              <v-toolbar flat dense color="light-green accent-3">
                <v-icon color="light-green darken-2">fa-check</v-icon>
                <v-toolbar-title style="color: green;"
                  >&nbsp;{{
                    $t("messages.reqRegister.confirmPopupText")
                  }}</v-toolbar-title
                >
                <div class="flex-grow-1"></div>
                <v-toolbar-items>
                  <v-btn icon @click="dialogConfirmSuccess = false">
                    <v-icon>mdi-close</v-icon>
                  </v-btn>
                </v-toolbar-items>
              </v-toolbar>
              <v-card-text dark color="green accent-1">
                <br />
                <span v-html="successText" style="color: green;">{{
                  successText
                }}</span>
              </v-card-text>
            </v-card>
          </v-dialog>

          <v-dialog v-model="dialogError" max-width="600px">
            <v-card tile>
              <v-toolbar flat dense color="red darken-3">
                <v-icon color="red lighten-5">fa-exclamation-circle</v-icon>
                <v-toolbar-title style="color: #ffebee;"
                  >&nbsp;{{ dialogErrorTitle }}</v-toolbar-title
                >
                <div class="flex-grow-1"></div>
                <v-toolbar-items>
                  <v-btn icon @click="dialogError = false">
                    <v-icon>mdi-close</v-icon>
                  </v-btn>
                </v-toolbar-items>
              </v-toolbar>
              <v-card-text dark color="red accent-1">
                <br />
                <span style="color: red;" v-html="errorText">{{
                  errorText
                }}</span>
              </v-card-text>
            </v-card>
          </v-dialog>

          <v-dialog v-model="dialogInfo" max-width="600px">
            <v-card tile>
              <v-toolbar flat dense color="green darken-3">
                <v-icon>fa-info</v-icon>
                <v-toolbar-title  style="color: #ffebee;">&nbsp;{{ dialogInfoTitle }}</v-toolbar-title>
                <div class="flex-grow-1"></div>
                <v-toolbar-items>
                  <v-btn icon @click="dialogInfo = false">
                    <v-icon>mdi-close</v-icon>
                  </v-btn>
                </v-toolbar-items>
              </v-toolbar>
              <v-card-text>
                <br />
                <span v-html="infoText">{{ infoText }}</span>
              </v-card-text>
            </v-card>
          </v-dialog>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import MasterDataProvider from "@/services/masterData_provider";
import EnrollProvider from "@/services/enroll_provider";

// eslint-disable-next-line no-unused-vars
const masterDataProvider = new MasterDataProvider();
// eslint-disable-next-line no-unused-vars
const enrollProvider = new EnrollProvider();

export default {
  name: "setCreditStuProbation",
  components: {},
  data() {
    return {
      bTable: {
        sortBy: "rowNumber",
        sortDesc: false,
        items: [],
        fields: [
          {
            key: "DESCRIPTION",
            label: this.$t("messages.general.description"),
            thClass: "align-middle",
            tdClass: "text-left text-nowarp",
            sortable: true,
          },
          {
            key: "CREDIT",
            label: this.$t("messages.general.variableValue"),
            thClass: "align-middle",
            tdClass: "text-left text-nowarp",
            sortable: true,
          },
        ],
      },

      perPageOptions: [
        { value: 10, text: 10 },
        { value: 50, text: 50 },
        { value: 100, text: 100 },
        { value: 500, text: 500 },
        { value: 1000, text: 1000 },
        { value: 2000, text: 2000 },
        { value: 3000, text: 3000 },
      ],
      perPage: 100,
      currentPage: 1,
      currentPageProgram: 1,
      currentPageStudentReserve: 1,
      currentPageStudentSearch: 1,
      dialogConfirmSuccess: false,
      successText: "",
      dialogError: false,
      errorText: "",
      dialogErrorTitle: "",
      dialogInfoTitle: "",
      infoText: "",
      dialogInfo: false,
      credit1: [],
      credit2: [],
      credit3: [],
    };
  },
  computed: {
    ...mapGetters("application", {
      appInfo: "getUserInfo",
      token: "getToken",
      userId: "getUserId",
      mfuUserId: "getMfuUserId",
    }),
    currentLang: function() {
      return this.appInfo.currentLocale;
    },
  },
  async mounted() {
    this.tokenHealthChk();
    this.togglePreLoader(true);
        const result = await enrollProvider.getConfigCredit({
          token: this.token,
          request: { },
        });
        console.log("result",result);

        this.bTable.items = [
        {
        DESCRIPTION:
          "หน่วยกิตที่สามารถลงทะเบียนได้ของนักศึกษาสภาพวิทยาทัณฑ์ ภาคเรียนที่ 1",
        CREDIT: result[0].SEMESTER1,
      },
      {
        DESCRIPTION:
          "หน่วยกิตที่สามารถลงทะเบียนได้ของนักศึกษาสภาพวิทยาทัณฑ์ ภาคเรียนที่ 2",
        CREDIT: result[0].SEMESTER2,
      },
      {
        DESCRIPTION:
          "หน่วยกิตที่สามารถลงทะเบียนได้ของนักศึกษาสภาพวิทยาทัณฑ์ ภาคเรียนที่ 3",
        CREDIT: result[0].SEMESTER3,
      },
    ];
    
    this.togglePreLoader(false);
  },
  methods: {
    ...mapActions("application", ["togglePreLoader", "tokenHealthChk"]),

    async saveCredit() {
      this.togglePreLoader(true);
      const temp = {
        token: this.token,
        request: {
          credit1: this.bTable.items[0].CREDIT,
          credit2: this.bTable.items[1].CREDIT,
          credit3: this.bTable.items[2].CREDIT,
          lang: this.currentLang,
        },
      };
      const result = await enrollProvider.saveConfigcredit(temp);
      this.togglePreLoader(false);

      if (result.status == 200) {
        this.dialogConfirmSuccess = true;
        this.successText = `${result.message.split(" ").join("<br/>")}`;
      } else {
        this.dialogErrorTitle = "";
        this.dialogError = true;
        this.errorText = `${result.message}`;
      }
    },
  },
  watch: {
    currentLang() {
      this.bTable.fields = [
        {
          key: "DESCRIPTION",
          label: this.$t("messages.general.description"),
          thClass: "align-middle",
          tdClass: "text-left text-nowarp",
          sortable: true,
        },
        {
          key: "CREDIT",
          label: this.$t("messages.general.variableValue"),
          thClass: "align-middle",
          tdClass: "text-left text-nowarp",
          sortable: true,
        },
      ];
    },
  },
};
</script>
